import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../hooks/styles';
import {Button} from '../../../button';
import {AcceptorsFilterList} from '../../components/list';
import {AcceptorsFilterViewBaseProps} from '../../model';

export default ({acceptorCategories, onSubmit}: AcceptorsFilterViewBaseProps) => {
  const styles = useStyles(() => ({
    container: {
      paddingBottom: 30,
    },
    filterButtonContainer: {},
    filterButton: {},
  }));
  return (
    <View style={styles.container}>
      <AcceptorsFilterList visuallyImpaired acceptorCategories={acceptorCategories} />
      <View style={[styles.filterButtonContainer]}>
        <Button id='filter-show' text='Показать' type='secondary' style={styles.filterButton} onPress={onSubmit} />
      </View>
    </View>
  );
};
